import { Controller } from "@hotwired/stimulus"
import { FroalaEditor, initTemplateEditor } from "src/froala_template_editor"

export default class extends Controller {
  connect() {
    this.initializeFroalaEditors()
  }

  confirmOfficialChange(event) {
    const checkbox = event.target
    
    // Only show confirmation when unchecking (making unofficial)
    if (!checkbox.checked) {
      const confirmed = confirm(
        "Are you sure you want to make this template unofficial?\n\n" +
        "Making a template unofficial will:\n" +
        "• Remove it from the super admin dashboard\n" +
        "• Make it only available in the associated account\n" +
        "• Remove it from the official template library\n\n" +
        "This action cannot be easily undone."
      )
      
      if (!confirmed) {
        // Re-check the checkbox if user cancels
        checkbox.checked = true
        event.preventDefault()
        return false
      }
    }
    
    return true
  }

  initializeFroalaEditors() {
    // Initialize Froala editor for super admin template edit page
    this.element.querySelectorAll(".template-form").forEach((templateFormDiv) => {
      const textareas = templateFormDiv.querySelectorAll("textarea")
      textareas.forEach((textarea) => {
        initTemplateEditor(textarea, {
          enter: FroalaEditor.ENTER_P,
          paragraphFormatDefaultSelection: "Paragraph",
          toolbarButtons: [
            "undo",
            "redo",
            "insertLink",
            "bold",
            "italic",
            "underline",
            "strikeThrough",
            "align",
            "formatUL",
            "insertImage",
          ],
        })
      })
    })
  }
}
